import React from "react";
import Header from "../common/Header";
import { useLocation } from "react-router-dom";
const Layout = (props) => {
  const location = useLocation();
  return (
    <>
      <div className="wrapper">
        <div
          className={`${location.pathname === "/login" ? "main px-0" : "main"}`}
        >
          {location.pathname === "/login" ? null : <Header />}
          {props.children}
        </div>
      </div>
    </>
  );
};
export default Layout;
